<h3 class="center m-t-20 m-b-10">
  {{ 'MENU_CMM.SURE_PUBLISH' | fallbackTranslate }}
  </h3>
  <div class="fs-12 center m-b-30">
    <span class="clr-green">  {{ 'MENU_CMM.PUBLISH_TIME' | fallbackTranslate }}</span>
  </div>
  <div class="loader-center" *ngIf="showLoader">{{ 'MENU_CMM.PUBLISH_DATA_LOADING' | fallbackTranslate }}...</div>
  <div class="content" *ngIf="!showLoader">
    <nz-table
    [nzData]="publishData?.restaurant"
    nzSize="'medium'"
    [nzScroll]="{ y: '150px' }"
    [nzShowPagination] = "false"
    [nzLoading]="isLoading"
    *ngIf="publishData?.restaurant?.length > 0"
    class="m-b-20"
  >
    <thead>
      <tr>
        <th scope="col" nzWidth="10%">S.NO </th>
        <th scope="col"  nzWidth="20%" nzAlign="center" nzWidth="20%">
          {{ 'MENU_CMM.RESTAURANT' | fallbackTranslate }}
        </th>
        <th scope="col" nzAlign="center" nzWidth="40%">
          {{ 'MENU_CMM.STATUS' | fallbackTranslate }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of publishData?.restaurant;let i = index">
        <td nzWidth="10%">
            <strong>{{ i + 1 }}</strong>
        </td>
        <td nzAlign="center" nzWidth="30%">
         <strong>{{ data?.name}}</strong>
        </td>
        <td
          nzAlign="center"
          nzWidth="70%%"
        >
        {{ data?.message}}
        </td>
      </tr>
    </tbody>
  </nz-table>  
  <nz-table
  [nzData]="publishData?.items"
  nzSize="'medium'"
  [nzShowPagination] = "false"
  [nzLoading]="isLoading"
  *ngIf="publishData?.items?.length > 0"
>
  <thead>
    <tr>
      <th scope="col" nzWidth="10%">S.NO </th>
      <th scope="col"  nzWidth="20%" nzAlign="center" nzWidth="20%">
        {{ 'MENU_CMM.DISH_NAME' | fallbackTranslate }}
      </th>
      <th scope="col" nzAlign="center" nzWidth="40%">
        {{ 'MENU_CMM.STATUS' | fallbackTranslate }}
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let data of publishData?.items; let i = index">
      <td nzWidth="10%">
          <strong>{{ i + 1 }}</strong>
      </td>
      <td nzAlign="center" nzWidth="30%">
       <strong>{{ data?.name}}</strong>
      </td>
      <td
        nzAlign="center"
        nzWidth="70%%"
      >
      {{ data?.message}}
      </td>
    </tr>
  </tbody>
  </nz-table>
  <nz-table
  [nzData]="publishData?.categories"
  nzSize="'medium'"
  [nzScroll]="{ y: '150px' }"
  [nzShowPagination] = "false"
  [nzLoading]="isLoading"
  *ngIf="publishData?.categories?.length > 0"
>
  <thead>
    <tr>
      <th scope="col" nzWidth="10%">S.NO </th>
      <th scope="col"  nzWidth="20%" nzAlign="center" nzWidth="20%">
        {{ 'MENU_CMM.CATEGORIES' | fallbackTranslate }}
      </th>
      <th scope="col" nzAlign="center" nzWidth="40%">
        {{ 'MENU_CMM.STATUS' | fallbackTranslate }}
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let data of publishData?.categories;let i = index">
      <td nzWidth="10%">
          <strong>{{  i + 1 }}</strong>
      </td>
      <td nzAlign="center" nzWidth="30%">
       <strong>{{ data?.name}}</strong>
      </td>
      <td
        nzAlign="center"
        nzWidth="70%%"
      >
      {{ data?.message}}
      </td>
    </tr>
  </tbody>
  </nz-table>

  <nz-table
  [nzData]="publishData?.subcategory"
  nzSize="'medium'"
  [nzScroll]="{ y: '150px' }"
  [nzShowPagination] = "false"
  [nzLoading]="isLoading"
  *ngIf="publishData?.subcategory?.length > 0"
>
  <thead>
    <tr>
      <th scope="col" nzWidth="10%">S.NO </th>
      <th scope="col"  nzWidth="20%" nzAlign="center" nzWidth="20%">
        {{ 'MENU_CMM.SUB_CATEGORY' | fallbackTranslate }}
      </th>
      <th scope="col" nzAlign="center" nzWidth="40%">
        {{ 'MENU_CMM.STATUS' | fallbackTranslate }}
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let data of publishData?.subcategory;let i = index">
      <td nzWidth="10%">
          <strong>{{  i + 1 }}</strong>
      </td>
      <td nzAlign="center" nzWidth="30%">
       <strong>{{ data?.name}}</strong>
      </td>
      <td
        nzAlign="center"
        nzWidth="70%%"
        *ngIf=" data?.message?.length"
      >
      {{ data?.message[0]}}
      </td>
    </tr>
  </tbody>
  </nz-table>
  <nz-table
  [nzData]="publishData?.variants"
  nzSize="'medium'"
  [nzScroll]="{ y: '150px' }"
  [nzShowPagination] = "false"
  [nzLoading]="isLoading"
  *ngIf="publishData?.variants?.length > 0"
  class="m-b-20"
>
  <thead>
    <tr>
      <th scope="col" nzWidth="10%">S.NO </th>
      <th scope="col"  nzWidth="20%" nzAlign="center" nzWidth="20%">
        {{ 'MENU_CMM.VARIANTS' | fallbackTranslate }}
      </th>
      <th scope="col" nzAlign="center" nzWidth="40%">
        {{ 'MENU_CMM.STATUS' | fallbackTranslate }}
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let data of publishData?.variants;let i = index">
      <td nzWidth="10%">
          <strong>{{ i + 1 }}</strong>
      </td>
      <td nzAlign="center" nzWidth="30%">
       <strong>{{ data?.name}}</strong>
      </td>
      <td
        nzAlign="center"
        nzWidth="70%%"
      >
      {{ data?.message}}
      </td>
    </tr>
  </tbody>
</nz-table>
</div>
<div class="modal-footer-content">
    <ng-container>
      <button class="button cancel-btn" (click)="dismissModal()"> {{ 'MENU_CMM.CANCEL' | fallbackTranslate }}</button>
      <button class="button save-btn" (click)="changesSync()" *ngIf="!showLoader">
        {{ 'MENU_CMM.YES_PUBLISH' | fallbackTranslate }}
      </button>
      <button class="button disable-save-btn"  *ngIf="showLoader">
        {{ 'MENU_CMM.YES_PUBLISH' | fallbackTranslate }}
      </button>
    </ng-container>
  </div>